import mime from 'mime';

import {
  AudioMimeType,
  FileType,
  ImageMimeType,
  MimeType,
  StrokeMimeType,
  VideoMimeType,
} from '../models/Base';

export const mimeTypeToFileType = (mimeType: MimeType): FileType => {
  switch (mimeType) {
    case ImageMimeType.Heic:
    case ImageMimeType.Heif:
    case ImageMimeType.Jpeg:
    case ImageMimeType.Png:
    case ImageMimeType.Webp:
      return FileType.Image;
    case AudioMimeType.Aac:
    case AudioMimeType.Mp3:
    case AudioMimeType.Mpeg:
    case AudioMimeType.Mpeg3:
      return FileType.Audio;
    case VideoMimeType.Mp4:
    case VideoMimeType.Mpegurl:
    case VideoMimeType.Quicktime:
    case VideoMimeType.Jpeg:
      return FileType.Video;
    case StrokeMimeType.Json:
    case StrokeMimeType.SvgXml:
      return FileType.Stroke;
  }
};

export const mimeTypeToExtension = (mimeType: MimeType) => {
  // Not all the file type supported by IOS/Android, so don't use mime.getExtension
  switch (mimeType) {
    case AudioMimeType.Aac:
      return 'aac';
    case AudioMimeType.Mp3:
    case AudioMimeType.Mpeg:
    case AudioMimeType.Mpeg3:
      return 'mp3';
    case VideoMimeType.Mp4:
    case VideoMimeType.Mpegurl:
      return 'mp4';
    case ImageMimeType.Jpeg:
      return 'jpeg';
    case ImageMimeType.Png:
      return 'png';
    case ImageMimeType.Webp:
      return 'webp';
    case ImageMimeType.Heic:
      return 'heic';
    case ImageMimeType.Heif:
      return 'heif';
    default:
      return '';
  }
};

export type Metadata = {
  filename: string;
  mimeType: MimeType;
  hash: string;
  size: number;
  fileType: FileType;
};

export type ImageMetadata = Metadata & {
  mimeType: ImageMimeType;
  aspectRatio: number;
};
export type AudioMetadata = Metadata & {
  mimeType: AudioMimeType;
};
export type VideoMetadata = Metadata & {
  mimeType: VideoMimeType;
  aspectRatio: number;
};
export type StrokeMetaData = Metadata & {
  mimeType: StrokeMimeType;
};
// type FileMetadata =
//   | ImageMetadata
//   | VideoMetadata
//   | AudioMetadata
//   | StrokeMetaData;

export const getMimeType = (path: string) => {
  // refactor some mime types
  const mimeType = mime.getType(path);
  if (mimeType === 'audio/x-aac') {
    return 'audio/aac';
  }
  return mimeType;
};

export const toPlatformFileVersion = <T extends string | undefined>(
  version: T,
): T => {
  // if (!canShowWebp()) {
  //   switch (version) {
  //     case ImageVersion.Small:
  //       return ImageVersion.LegacySmall as T;
  //     case ImageVersion.Medium:
  //       return ImageVersion.LegacyMedium as T;
  //     case ImageVersion.Large:
  //       return ImageVersion.LegacyLarge as T;
  //     case ImageVersion.ExtraLarge:
  //       return ImageVersion.LegacyExtraLarge as T;
  //   }
  // }
  return version;
};
